// 열려 있는 동안 + 닫힘 애니메이션 동안만 Portal 내용물을 붙여 둔다 — ⓘ 팝오버·요금표 팝오버 공용(2026-09-27 말풍선 전수조사).
// 처음 열기 전에는 붙이지 않는다: 닫힌 ⓘ(가이드 도움말만 61곳)마다 빈 div.chakra-portal 이 body 에 쌓이지 않게.
// 닫힌 뒤에는 애니메이션 시간이 지나면 떼어 낸다: Chakra 팝오버의 닫힘 애니메이션이 끝에 visibility: hidden 을 넣는데,
// 스크롤 도중 닫히면 그 마무리가 빠져 투명한(opacity 0) 빈 상자가 visibility: visible · pointer-events: auto 로 남아
// 그 자리의 클릭을 가로챘다(시뮬레이션 실측 285×2px). 애니메이션 마무리에 기대지 않고 아예 떼어 낸다.
import { useEffect, useState } from "react";

export const CLOSE_ANIMATION_MS = 200; // Chakra 팝오버 닫힘 애니메이션 100ms + 여유

export default function useMountedWhileOpen(isOpen, delayMs = CLOSE_ANIMATION_MS) {
  const [mounted, setMounted] = useState(isOpen);
  useEffect(() => {
    if (isOpen) {
      setMounted(true);
      return undefined;
    }
    const t = setTimeout(() => setMounted(false), delayMs);
    return () => clearTimeout(t);
  }, [isOpen, delayMs]);
  return isOpen || mounted;
}
